__turbopack_context__.v({
  "fallbackContainer": "DxGusW_fallbackContainer",
});
